import * as React from 'react'

import { HeroRedesign } from 'sdk/sections/hero-redesign/HeroRedesign'

import type { SoundcoreHeroCmsContent } from 'core/services/cms/interfaces'

import audioWaveIcon from './assets/audio-wave.svg'
import soundcoreHeroBgLarge from './assets/soundcore-hero-bg-large.jpg'
import soundcoreHeroBgSmall from './assets/soundcore-hero-bg-small.jpg'
import soundcoreHeroBgXsm from './assets/soundcore-hero-bg-xsm.jpg'


interface HeroProps {
  content: SoundcoreHeroCmsContent
}

export const Hero: React.FC<HeroProps> = ({ content }) => {
  return (
    <HeroRedesign
      imageDesktop={soundcoreHeroBgLarge}
      imageTablet={soundcoreHeroBgSmall}
      imageMobile={soundcoreHeroBgXsm}
      pillText={content.pillText}
      pillIcon={audioWaveIcon}
      titleText={content.titleText}
      description={content.description}
      alwaysCentered
    />
  )
}
